module.exports = __webpack_public_path__ + "img/predators-white.2924e0d9.svg";